// Sidebar + content shell for every /merchant/* route. Reuses the admin CSS
// (portal-* class names) since the merchant portal is visually identical —
// just a different nav set and brand label.

import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../admin/AdminLayout.css';

const NAV = [
  { to: '/merchant', label: 'Dashboard', end: true },
  { to: '/merchant/coupons', label: 'Coupons' },
  { to: '/merchant/flyers', label: 'Flyers' },
  { to: '/merchant/subscription', label: 'Subscription' },
];

export default function MerchantLayout() {
  const { user } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const storeLabel = user?.owned_stores?.[0]?.name || 'No store linked';

  useEffect(() => { setDrawerOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (drawerOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const activeLabel = NAV.find(n =>
    n.end ? location.pathname === n.to : location.pathname.startsWith(n.to)
  )?.label || 'Merchant';

  return (
    <div className="portal-shell">
      <div className="portal-mobile-bar">
        <button
          type="button"
          className="portal-menu-toggle"
          aria-label="Open navigation"
          onClick={() => setDrawerOpen(true)}
        >☰</button>
        <span className="portal-mobile-title">{activeLabel}</span>
      </div>

      <div
        className={`portal-sidebar-backdrop${drawerOpen ? ' open' : ''}`}
        onClick={() => setDrawerOpen(false)}
      />

      <nav className={`portal-sidebar${drawerOpen ? ' open' : ''}`}>
        <div className="portal-sidebar-brand">
          Merchant Portal
          <small>{storeLabel}</small>
        </div>
        {NAV.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <main className="portal-content">
        <Outlet />
      </main>
    </div>
  );
}
